import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import MensalistaWelcome from '../components/MensalistaWelcome';
import { supabase } from '../services/supabaseClient';

const WelcomePage = () => {
  const navigate = useNavigate();
  const { currentUser } = useApp();
  const [fotoUrl, setFotoUrl] = React.useState("");
  const [loadingFoto, setLoadingFoto] = React.useState(true);

  // Redirecionar para a página inicial se não houver usuário logado
  React.useEffect(() => {
    if (!currentUser) {
      navigate('/');
    }
  }, [currentUser, navigate]);

  // Buscar foto_url do mensalista
  React.useEffect(() => {
    async function fetchFotoUrl() {
      setLoadingFoto(true);
      if (!currentUser?.name) {
        setFotoUrl("");
        setLoadingFoto(false);
        return;
      }
      // Busca pelo nome do mensalista (case-insensitive)
      const { data, error } = await supabase
        .from('mensalistas')
        .select('foto_url')
        .ilike('nome', currentUser.name)
        .single();
      if (!error && data && data.foto_url) {
        setFotoUrl(data.foto_url);
      } else {
        setFotoUrl("");
      }
      setLoadingFoto(false);
    }
    fetchFotoUrl();
  }, [currentUser]);

  const handleStartService = () => {
    navigate('/menu');
  };

  if (loadingFoto) return null; // ou um spinner se preferir

  return (
    <MensalistaWelcome
      name={currentUser?.name || ''}
      fotoUrl={fotoUrl}
      onStartService={handleStartService}
    />
  );
};

export default WelcomePage;
